var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-element-loading',{attrs:{"active":true,"is-full-screen":_vm.fullScreen,"spinner":"ring","size":_vm.size,"background-color":"rgba(255, 255, 255, 0.75)","color":"#082154"}})}
var staticRenderFns = []

export { render, staticRenderFns }